module.exports = __webpack_public_path__ + "img/reservation-upgrade.43a62bfc.svg";